<div class="">

  <!-- Top Breadcrumbs Bar with Search & Create FAQ on Right (Exact Ticket Style) -->
  <div class="ticket-breadcrumb-wrapper ticket-breadcrumb-flex">
    <div class="breadcrumb-left-side">
      <app-breadcrumb></app-breadcrumb>
    </div>

    <div class="breadcrumb-right-actions">
      <!-- Search Bar -->
      <form class="fd-top-search-form" autocomplete="off" role="search" (submit)="$event.preventDefault()" style="margin: 0; display: inline-flex;">
        <div class="fd-top-search-wrapper">
          <i class="fa fa-search fd-top-search-icon"></i>
          <input 
            type="search" 
            name="topSearchFaqInput"
            id="topSearchFaqInput"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            class="fd-top-search-input" 
            placeholder="Search questions or answers..." 
            [(ngModel)]="searchQuery" 
            (input)="onSearchChange()" />
          <span *ngIf="searchQuery" class="fd-clear-search-btn" (click)="searchQuery = ''; onSearchChange()">&times;</span>
        </div>
      </form>

      <!-- Create FAQ Button (Exact Ticket Component Button Style) -->
      <button type="button" class="fd-btn fd-btn-create-ticket" (click)="openCreateModal()" id="btnCreateFaq" title="Create New FAQ">
        <i class="fa fa-plus"></i> Create FAQ
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="fd-loading-state">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
    <span>Loading FAQs from database...</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && filteredFaqs.length === 0" class="fd-empty-state">
    <div class="fd-empty-icon">
      <i class="fa fa-question-circle"></i>
    </div>
    <h3 class="fd-empty-title">No FAQs Found</h3>
  </div>

  <!-- FAQ List Cards (Ticket-Style Cards) -->
  <div *ngIf="!isLoading && filteredFaqs.length > 0" class="fd-faq-list">
    <div 
      *ngFor="let faq of filteredFaqs; let i = index" 
      class="fd-faq-card" 
      [class.selected]="isFaqSelected(faq)">
      
      <!-- Card Left: Order Avatar Circle -->
      <div class="fd-card-left">
        <div class="fd-avatar-circle" [ngStyle]="{'background-color': getAvatarColor(faq)}">
          {{ faq.display_order || (i + 1) }}
        </div>
      </div>

      <!-- Card Center: Badges, Title, Answer Body, Meta -->
      <div class="fd-card-center" (click)="toggleExpand(faq, $event)">
        <!-- Badges Row -->
        <div class="fd-badges-row">
          <span class="fd-badge fd-badge-order">Order #{{ faq.display_order || (i + 1) }}</span>
          <span class="fd-badge fd-badge-status" [class.inactive]="faq.is_active === false" (click)="toggleFaqVisibility(faq, $event)" title="Click to toggle visibility">
            <span class="fd-status-dot" [class.inactive]="faq.is_active === false"></span>
            {{ faq.is_active === false ? 'Hidden in Support Widget' : 'Active in Support Widget' }}
          </span>
        </div>

        <!-- Question Title -->
        <div class="fd-faq-title-row">
          <h3 class="fd-faq-question">{{ faq.question }}</h3>
          <span class="fd-faq-id" *ngIf="faq.id">#{{ faq.id }}</span>
        </div>

        <!-- Answer Description Preview / Full -->
        <div class="fd-faq-answer" [class.expanded]="isExpanded(faq)">
          <p class="fd-answer-text">{{ faq.answer }}</p>
        </div>

        <!-- Meta Line -->
        <div class="fd-faq-meta">
          <span class="fd-meta-item">
            <i class="fa fa-sort-numeric-down fd-meta-icon"></i>
            Display Order: {{ faq.display_order || (i + 1) }}
          </span>
          <span class="fd-meta-dot" *ngIf="faq.created_at">&middot;</span>
          <span class="fd-meta-item" *ngIf="faq.created_at">
            <i class="fa fa-clock fd-meta-icon"></i>
            Created {{ faq.created_at | date:'mediumDate' }}
          </span>
          <span class="fd-meta-dot">&middot;</span>
          <button type="button" class="fd-toggle-expand-btn" (click)="toggleExpand(faq, $event)">
            {{ isExpanded(faq) ? 'Show less' : 'Show more' }}
            <i class="fa" [ngClass]="isExpanded(faq) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>

      <!-- Card Right: Actions (Visible/Hidden, Edit & Delete) -->
      <div class="fd-card-right">
        <!-- Show / Hide Button in Button Format -->
        <button 
          type="button" 
          class="fd-row-action-btn visibility-btn" 
          [class.is-hidden]="faq.is_active === false"
          (click)="toggleFaqVisibility(faq, $event)" 
          [title]="faq.is_active === false ? 'Click to show in support widget' : 'Click to hide from support widget'"
          [attr.aria-label]="faq.is_active === false ? 'Show FAQ' : 'Hide FAQ'">
          <i class="fa" [ngClass]="faq.is_active === false ? 'fa-eye' : 'fa-eye-slash'"></i>
          <span>{{ faq.is_active === false ? 'Show' : 'Hide' }}</span>
        </button>

        <button 
          type="button" 
          class="fd-row-action-btn edit-btn" 
          (click)="openEditModal(faq, $event)" 
          title="Edit FAQ"
          aria-label="Edit FAQ">
          <i class="fa fa-pencil-alt"></i>
          <span>Edit</span>
        </button>

        <button 
          type="button" 
          class="fd-row-action-btn delete-btn" 
          (click)="confirmDeleteFaq(faq, $event)" 
          title="Delete FAQ"
          aria-label="Delete FAQ">
          <i class="fa fa-trash-alt"></i>
          <span>Delete</span>
        </button>
      </div>
    </div>
  </div>

  <!-- =========================================================================
       CREATE / EDIT MODAL DIALOG (Standard Certiplate Form Style)
       ========================================================================= -->
  <div *ngIf="showCreateModal" class="vss-modal show" (click)="closeCreateModal()">
    <div class="vss-modal-dialog" (click)="$event.stopPropagation()">
      <div class="vss-modal-content">
        <!-- Modal Header -->
        <div class="vss-modal-header">
          <h3 class="vss-modal-title">{{ isEditing ? 'Edit FAQ' : 'Create FAQ' }}</h3>
          <button type="button" class="vss-close" (click)="closeCreateModal()" aria-label="Close modal">&times;</button>
        </div>

        <!-- Modal Body -->
        <div class="vss-modal-body">
          <form (ngSubmit)="saveFaq()" #faqModalForm="ngForm">
            <!-- Question / Header Field -->
            <div class="form-group mb-3">
              <label for="faqQuestionInput" class="form-control-label">
                Header / Question <span class="text-danger">*</span>
              </label>
              <input 
                type="text" 
                id="faqQuestionInput" 
                class="form-control" 
                [(ngModel)]="faqForm.question" 
                name="question" 
                placeholder="Enter Question Header" 
                maxlength="300" 
                required />
            </div>

            <!-- Answer / Description Field -->
            <div class="form-group mb-3">
              <label for="faqAnswerTextarea" class="form-control-label">
                Description / Answer <span class="text-danger">*</span>
              </label>
              <textarea 
                id="faqAnswerTextarea" 
                class="form-control" 
                rows="6" 
                [(ngModel)]="faqForm.answer" 
                name="answer" 
                placeholder="Enter Description / Answer" 
                required></textarea>
            </div>

            <!-- Display Order Field -->
            <div class="form-group mb-3">
              <label for="faqDisplayOrder" class="form-control-label">
                Display Order
              </label>
              <input 
                type="number" 
                id="faqDisplayOrder" 
                class="form-control" 
                [(ngModel)]="faqForm.display_order" 
                name="display_order" 
                placeholder="Enter Display Order" 
                min="1" />
            </div>

            <!-- Submit and Cancel Buttons (Standard Certiplate Form Actions) -->
            <div class="row" style="margin-top: 24px; margin-bottom: 8px;">
              <div class="col-lg-12">
                <div class="d-flex" style="justify-content: center; gap: 1rem;">
                  <button type="button" class="cancelbtn" (click)="closeCreateModal()" [disabled]="isSaving">
                    Cancel
                  </button>
                  <button type="submit" class="submitbtn" (click)="saveFaq()" [disabled]="isSaving || !faqForm.question.trim() || !faqForm.answer.trim()">
                    {{ isSaving ? 'Saving...' : (isEditing ? 'Update' : 'Save') }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- =========================================================================
       DELETE CONFIRMATION MODAL
       ========================================================================= -->
  <div *ngIf="showDeleteModal && deletingFaq" class="vss-modal show" (click)="closeDeleteModal()">
    <div class="vss-modal-dialog vss-modal-sm" (click)="$event.stopPropagation()">
      <div class="vss-modal-content">
        <div class="vss-modal-header">
          <h3 class="vss-modal-title">Delete FAQ</h3>
          <button type="button" class="vss-close" (click)="closeDeleteModal()">&times;</button>
        </div>

        <div class="vss-modal-body">
          <p class="delete-warning-text">
            Are you sure you want to delete this FAQ item? It will be permanently removed from the support widget.
          </p>
          <div class="delete-faq-preview">
            <strong>{{ deletingFaq.question }}</strong>
          </div>

          <div class="row" style="margin-top: 20px; margin-bottom: 4px;">
            <div class="col-lg-12">
              <div class="d-flex" style="justify-content: center; gap: 1rem;">
                <button type="button" class="cancelbtn" (click)="closeDeleteModal()" [disabled]="isDeleting">
                  Cancel
                </button>
                <button type="button" class="submitbtn" (click)="executeDeleteFaq()" [disabled]="isDeleting" style="background-color: #dc2626;">
                  {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
